import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Lleva el scroll a la sección indicada por el hash (#precios, #faq…).
 * Se usa en la landing porque el navbar enlaza secciones desde otras páginas.
 * Corre después de ScrollToTop, que ya llevó la vista al inicio.
 */
export function useHashScroll() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = hash.slice(1);
        const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        // Esperamos un frame para que la sección ya esté en el DOM y medida.
        const raf = requestAnimationFrame(() => {
            document.getElementById(id)?.scrollIntoView({
                behavior: reduce ? "auto" : "smooth",
                block: "start",
            });
        });
        return () => cancelAnimationFrame(raf);
    }, [hash]);
}
